import React, { Component, Fragment } from 'react';
import { observer } from 'mobx-react';
import b from 'b_';
import { FTBody, Card } from '../../Fuse';
import UrlIsolationOptionsStore from '../../../stores/Policy/BrowsingRoles/UrlIsolationOptionsStore';
import PolicySection from '../PolicySection';
import AllowAnonymousRegistrationField from './AnonymousRegistrationField';
import RegistrationStatusField from './RegistrationStatusField';
import RegistrationTypeField from './RegistrationTypeField';
import './UrlIsolationOptions.css';
import { FuseConsoleCardFooter } from '../../ConsoleFragments';

const block = b.lock('UrlIsolationOptions');

class UrlIsolationOptions extends Component {
    static propTypes = {
        store: UrlIsolationOptionsStore.PropType.isRequired,
    };

    render() {
        const { store } = this.props;

        return <Card title="URL Isolation Options">
            <PolicySection className={block('Section')}>
                <FTBody className={block('Heading')}>Browser Registration</FTBody>
                <div className={block('Field')}>
                    <RegistrationStatusField
                        store={store.browserRegistrationEnabled}
                        info={'URL Isolation always registers automatically.'}
                        readOnly
                    />
                </div>
                {store.browserRegistrationEnabled.getValue() ? <Fragment>
                    <div className={block('Field')}>
                        <AllowAnonymousRegistrationField
                            store={store.anonymousUsage}
                            info={'URL Isolation users are not allowed to browse anonymously.'}
                            readOnly
                        />
                    </div>
                    <div className={block('Field')}>
                        <RegistrationTypeField
                            store={store.browserAuthenticationMethod}
                            info={'The browser is re-registered using the encoded email of a ' +
                            'rewritten link each time it is clicked.'}
                            readOnly
                        />
                    </div>
                </Fragment> : null}

                <FuseConsoleCardFooter
                    text={'Browser Registration options for URL Isolation cannot be changed. ' +
                    'Role is matched using the encoded user in the rewritten link.'}
                />
            </PolicySection>
        </Card>;
    }
}

export default observer(UrlIsolationOptions);
